import { STORAGE_KEYS as i } from "./storage-manager.js";
import E from "./subscription-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
export default class kt {
  constructor(t, i, s) {
    (this.u = t),
      (this.gh = i),
      (this.ph = s),
      (this.u = t),
      (this.gh = i || !1),
      (this.ph = s),
      (this.Fh = new E()),
      (this.kh = 0),
      (this.fh = 1);
  }
  wh() {
    return this.gh;
  }
  jh() {
    return this.u.v(i.k.xh);
  }
  setSdkAuthenticationSignature(t) {
    const s = this.jh();
    this.u.D(i.k.xh, t);
    const e = r.zt.Ft;
    new r.xt(e, r.j).setItem(e.Jt.qh, this.fh, t), s !== t && this.ti();
  }
  yh() {
    this.u.ni(i.k.xh);
    const t = r.zt.Ft;
    new r.xt(t, r.j).oe(t.Jt.qh, this.fh);
  }
  subscribeToSdkAuthenticationFailures(t) {
    return this.ph.lt(t);
  }
  Bh(t) {
    this.ph.Et(t);
  }
  Gh() {
    this.Fh.removeAllSubscriptions();
  }
  Hh() {
    this.kh += 1;
  }
  Jh() {
    return this.kh;
  }
  ti() {
    this.kh = 0;
  }
}
